import AuthRequest from './AuthRequest';
import HttpResponseCodes from './HttpResponseCodes';
import AxiosInterceptor from './Interceptors/AxiosInterceptor';

class RequestInterceptor {

    /**
     *
     */
    constructor() {
        this.xhrLib = AuthRequest.xhrLib;
        this.authorizationHeaderKey = 'Authorization';
    }

    /**
     *
     * @param options
     * @returns {AxiosInterceptor}
     */
    config(options) {
        if (options.hasOwnProperty('store')) {
            this.store = options.store;
        }
        if (options.hasOwnProperty('router')) {
            this.router = options.router;
        }
        if (options.hasOwnProperty('xhrLib')) {
            this.xhrLib = options.xhrLib;
        }
        if (options.hasOwnProperty('authorizationHeaderKey')) {
            this.authorizationHeaderKey = options.authorizationHeaderKey;
        }
        if (options.hasOwnProperty('unifiedLogin')) {
            this.unifiedLogin = options.unifiedLogin;
        }
        return this;
    }

    /**
     *
     * @returns {AxiosInterceptor|RequestInterceptor}
     */
    interceptRequests() {
        /**
         * @todo implement axios library check
         */
        return AxiosInterceptor
            .config(this.interceptorConfig())
            .interceptRequests();

        return this;
    }

    /**
     *
     * @returns {{xhrLib: function, authorizationHeaderKey: string}}
     */
    interceptorConfig(){
        const config = {
            xhrLib: this.xhrLib,
            authorizationHeaderKey: this.authorizationHeaderKey,
            unifiedLogin: true,
            internalDomains: [window.env.MILESTONES_DOMAIN]
        };
        if (this.hasOwnProperty('store')){
            config.store = this.store;
        }
        if (this.hasOwnProperty('router')){
            config.router = this.router;
        }
        if (this.hasOwnProperty('unifiedLogin')){
            config.unifiedLogin = this.unifiedLogin;
        }
        return config;
    }

    /**
     *
     * @returns {boolean}
     */
    isLoggedIn() {
        return this.hasOwnProperty('store') &&
            this.store.getters.isUserAuthenticated &&
            this.store.getters.authToken;
    }
}

export default new RequestInterceptor();
